import React from 'react'

export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M13.4168 8.66671H9.41683V12.6667H8.0835V8.66671H4.0835V7.33337H8.0835V3.33337H9.41683V7.33337H13.4168V8.66671Z"
      fill="#282828"
    />
  </svg>
)
